<template>
  <div class="mt-2">
    <div class="row">
      <div class="col">
        <div class="pb-1">Product condition</div>
        <div class="d-flex flex-row">
          <div class="form-check form-check-inline pr-15">
            <input
              class="form-check-input mr-2"
              id="top40"
              type="radio"
              v-model="form.hasTop40Products"
              name="hasTop40Products"
              :value="true"
              :class="{
                'input--error': isSubmit && error.errorHasTop40Products,
              }"
            />
            <label class="form-check-label" for="top40">Top 40</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input mr-2"
              id="nonTop40"
              type="radio"
              v-model="form.hasTop40Products"
              name="hasTop40Products"
              :value="false"
              :class="{
                'input--error': isSubmit && error.errorHasTop40Products,
              }"
            />
            <label class="form-check-label" for="nonTop40">Non-top 40</label>
          </div>
          <div
            v-if="isSubmit && error.errorHasTop40Products"
            class="text-error"
          >
            {{ error.errorHasTop40Products.message }}
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="top-40-upload-container p-4">
              <a
                href="#"
                target="_blank"
                class="download-sample-file-link"
                @click.prevent="downloadSampleFile"
                >Download sample file</a
              >
              <div class="row d-flex align-items-center">
                <div class="col-10">
                  <input
                    type="file"
                    class="form-control my-2"
                    @change="uploadTop40File"
                    :disabled="isFileLoading"
                    :class="{
                      'input--error':
                        isSubmit && error.errorTop40ProductsFilePath,
                    }"
                  />
                  <div
                    v-if="isSubmit && error.errorTop40ProductsFilePath"
                    class="text-error"
                  >
                    {{ error.errorTop40ProductsFilePath.message }}
                  </div>
                </div>
                <div class="col-2">
                  <FileLoading v-if="isFileLoading" />
                </div>
              </div>

              <a
                v-if="form.currentTop40ProductsFilePath"
                href="#"
                target="_blank"
                class="trigger"
                @click.prevent="downloadCurrentFile"
                >Download current Top 40 file</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import FileLoading from "components/Loading/FileLoading.vue";

export default {
  name: "Top40ProductCondition",
  components: { FileLoading },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: () => {},
    },
    isSubmit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isFileLoading: false,
    };
  },
  methods: {
    uploadTop40File(e) {
      if (e.target.files) {
        const file = e.target.files[0];
        this.getPresignURL(file);
      }
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("crmTrigger", file)
        .then((res) => {
          const data = res.data;
          this.form.top40ProductsTempFilePath = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
    },
    downloadSampleFile() {
      try {
        window.open(
          process.env.VUE_APP_HOST_API + "/static/sample/sampleTop40.xlsx"
        );
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    downloadCurrentFile() {
      try {
        window.open(this.form.currentTop40ProductsFilePath);
      } catch (error) {
        console.log("Error: ", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}

.top-40-upload-container {
  border: 1px dashed #ccc;
  border-radius: 15px;
}

.download-sample-file-link {
  color: #6e6e6e;
}
</style>
